export function getClosestData(chromatogram, time, options = {}) {
    const { seriesName = 'ms' } = options;
    chromatogram.requiresSeries(seriesName);
    const closest = chromatogram.getClosestTime(time);
    return {
        rt: chromatogram.getTimes()[closest],
        index: closest,
        data: chromatogram.getSeries(seriesName).getData()[closest],
    };
}
//# sourceMappingURL=get_closest_data.js.map